import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { t } from "@/lib/i18n";
import { AutoBIMLogo } from "@/components/Brand";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { Button, Input, Card } from "@/components/ui";

export default function Register() {
  const { signUp, lang } = useAuth();
  const isAr = lang === "ar";
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(null);
    if (!fullName || !email || !password) return setErr(t("required", lang));
    if (password.length < 6) return setErr(isAr ? "كلمة المرور 6 أحرف على الأقل" : "Password must be at least 6 characters");
    setLoading(true);
    try {
      await signUp(email.trim().toLowerCase(), password, fullName.trim());
      navigate("/studio");
    } catch (ex) {
      setErr(ex.message || t("error_generic", lang));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="relative min-h-screen abl-grid-bg">
      <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-5 py-10">
        <div className="mb-4 flex justify-end"><LanguageSwitcher /></div>
        <div className="mb-6 flex flex-col items-center gap-3">
          <AutoBIMLogo size={64} />
          <div className="text-3xl font-black">AutoBIM<span className="italic text-accent"> Logic</span></div>
        </div>
        <Card>
          <h1 className="mb-4 text-xl font-black">{t("signUp", lang)}</h1>
          <form onSubmit={submit} className="space-y-3">
            <Input label={isAr ? "الاسم الكامل" : "Full name"} value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder={isAr ? "م. أحمد" : "Eng. John"} data-testid="register-name-input" />
            <Input label={t("email", lang)} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="register-email-input" />
            <Input label={t("password", lang)} type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="register-password-input" />
            {err && <p className="text-sm text-destructive" data-testid="register-error">{err}</p>}
            <Button type="submit" className="w-full" loading={loading} data-testid="register-submit-button">{isAr ? "إنشاء حساب مجاني" : "Create free account"}</Button>
          </form>
          <p className="mt-4 text-center text-sm text-muted-foreground">
            {isAr ? "لديك حساب؟" : "Already have an account?"}{" "}
            <Link to="/login" className="font-bold text-primary" data-testid="goto-login-link">{t("signIn", lang)}</Link>
          </p>
        </Card>
      </div>
    </div>
  );
}
